import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a9609782"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "security-check" }
const _hoisted_2 = { class: "mt-6 bg-white border px-4 py-2" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!
  const _component_the_textarea = _resolveComponent("the-textarea")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_before_checked_information = _resolveComponent("before-checked-information")!
  const _component_information_handler = _resolveComponent("information-handler")!
  const _component_person_information = _resolveComponent("person-information")!
  const _component_company_information = _resolveComponent("company-information")!
  const _component_auto_information = _resolveComponent("auto-information")!
  const _component_history = _resolveComponent("history")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.decline_state.is_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          class: "large",
          title: _ctx.declineModalTitle,
          loading: _ctx.state.is_person_decline_loading || _ctx.state.is_company_decline_loading,
          onCancel: _ctx.closeDecline,
          onConfirm: _ctx.declineManager
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_input, {
              placeholder: "Причина отказа",
              value: _ctx.decline_state.comment,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.decline_state.comment) = $event)),
              "is-invalid": _ctx.decline_form$.comment.$error,
              "validation-errors": _ctx.decline_form$.comment.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"])
          ]),
          _: 1
        }, 8, ["title", "loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.accept_state.is_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 1,
          class: "large",
          title: "Укажите комментарий",
          loading: _ctx.state.is_person_decline_loading || _ctx.state.is_company_decline_loading,
          onCancel: _ctx.closeAccept,
          onConfirm: _ctx.acceptManager
        }, {
          default: _withCtx(() => [
            _createVNode(_component_the_textarea, {
              value: _ctx.accept_state.comment,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.accept_state.comment) = $event)),
              class: "w-full",
              placeholder: "Добавьте ваш комментарий",
              rows: 5,
              autoheight: ""
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    _createVNode(_component_page_title, { title: "Проверка службы безопасности" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_checkbox, {
            label: "Юридическое лицо",
            disabled: !_ctx.isHaveCompanyAccess || _ctx.isSomeRequestInProgress,
            value: _ctx.state.is_company_data,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.is_company_data) = $event)),
            onChange: _ctx.onByCompany
          }, null, 8, ["disabled", "value", "onChange"]),
          _createVNode(_component_checkbox, {
            class: "ml-3",
            disabled: !_ctx.isHavePersonAccess || _ctx.isSomeRequestInProgress,
            label: "Физическое лицо",
            value: _ctx.state.is_person_data,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.is_person_data) = $event)),
            onChange: _ctx.onByPerson
          }, null, 8, ["disabled", "value", "onChange"]),
          _createVNode(_component_checkbox, {
            class: "ml-3",
            disabled: !_ctx.isHavePersonAccess || _ctx.isSomeRequestInProgress,
            label: "Авто",
            value: _ctx.state.is_auto_data,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.is_auto_data) = $event)),
            onChange: _ctx.onByAuto
          }, null, 8, ["disabled", "value", "onChange"])
        ]),
        _createVNode(_component_checkbox, {
          class: "ml-3",
          label: "Ручная проверка",
          value: _ctx.state.is_manually,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.is_manually) = $event)),
          disabled: _ctx.isSomeRequestInProgress
        }, null, 8, ["value", "disabled"])
      ]),
      _createElementVNode("form", {
        class: _normalizeClass(["security-check__form mt-3", { 'form--auto': _ctx.state.is_auto_data }]),
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCreateInformationRequest && _ctx.onCreateInformationRequest(...args)), ["prevent"]))
      }, [
        (_ctx.state.is_person_data)
          ? (_openBlock(), _createBlock(_component_the_input, {
              key: 0,
              value: _ctx.state.person_iin,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.person_iin) = $event)),
              placeholder: "ИИН",
              disabled: !_ctx.isHavePersonAccess || _ctx.isSomeRequestInProgress,
              "is-invalid": _ctx.state_form$.person_iin.$error,
              "validation-errors": _ctx.state_form$.person_iin.$errors
            }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]))
          : _createCommentVNode("", true),
        (_ctx.state.is_company_data)
          ? (_openBlock(), _createBlock(_component_the_input, {
              key: 1,
              value: _ctx.state.company_bin,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.company_bin) = $event)),
              placeholder: "БИН",
              disabled: !_ctx.isHaveCompanyAccess || _ctx.isSomeRequestInProgress,
              "is-invalid": _ctx.state_form$.company_bin.$error,
              "validation-errors": _ctx.state_form$.company_bin.$errors
            }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]))
          : _createCommentVNode("", true),
        (_ctx.state.is_auto_data)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createVNode(_component_the_input, {
                value: _ctx.state.auto_number,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.auto_number) = $event)),
                placeholder: "Гос. номер (например: 849ani02)",
                disabled: !_ctx.isHaveAutoAccess || _ctx.isSomeRequestInProgress,
                "is-invalid": _ctx.state_form$.auto_number.$error,
                "validation-errors": _ctx.state_form$.auto_number.$errors
              }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
              _createVNode(_component_the_input, {
                value: _ctx.state.auto_technical_passport,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.auto_technical_passport) = $event)),
                placeholder: "№ Тех. паспорта",
                disabled: !_ctx.isHaveAutoAccess || _ctx.isSomeRequestInProgress,
                "is-invalid": _ctx.state_form$.auto_technical_passport.$error,
                "validation-errors": _ctx.state_form$.auto_technical_passport.$errors
              }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
            ], 64))
          : _createCommentVNode("", true),
        (!_ctx.state.is_manually)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 3,
              class: "primary small mt-2 py-3",
              type: "submit",
              disabled: _ctx.isCheckDisabled || _ctx.isSomeRequestInProgress,
              loading: _ctx.isCheckLoading
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" Проверить ")
              ]),
              _: 1
            }, 8, ["disabled", "loading"]))
          : _createCommentVNode("", true)
      ], 34)
    ]),
    (_ctx.before_checked_state.is_checked)
      ? (_openBlock(), _createBlock(_component_before_checked_information, {
          key: 2,
          class: "mt-6",
          loading: _ctx.before_checked_state.is_loading,
          "is-confirmed": _ctx.before_checked_state.is_accepted,
          "is-declined": _ctx.before_checked_state.is_checked && !_ctx.before_checked_state.is_accepted,
          "is-accepted": _ctx.before_checked_state.is_accepted,
          "decline-reason": _ctx.before_checked_state.comment,
          type: _ctx.currentType
        }, null, 8, ["loading", "is-confirmed", "is-declined", "is-accepted", "decline-reason", "type"]))
      : _createCommentVNode("", true),
    (_ctx.isInformationHandlerRender)
      ? (_openBlock(), _createBlock(_component_information_handler, {
          key: 3,
          class: "mt-6",
          "is-not-found": 
                _ctx.state.is_person_not_found || _ctx.state.is_company_not_found || _ctx.state.is_auto_not_found
            ,
          "not-found-message": _ctx.state.not_found_message,
          "is-in-progress": 
                _ctx.state.is_person_in_progress ||
                _ctx.state.is_company_in_progress ||
                _ctx.state.is_auto_in_progress
            
        }, null, 8, ["is-not-found", "not-found-message", "is-in-progress"]))
      : _createCommentVNode("", true),
    (_ctx.isPersonInformationRender)
      ? (_openBlock(), _createBlock(_component_person_information, {
          key: 4,
          class: "mt-6",
          person: _ctx.state.person_information,
          "is-confirm-loading": _ctx.state.is_person_confirm_loading,
          "is-decline-loading": _ctx.state.is_person_decline_loading,
          "is-can-confirm": _ctx.isCanConfirm && !!_ctx.state.person_iin,
          "is-can-decline": _ctx.isCanDecline && !!_ctx.state.person_iin,
          onConfirm: _ctx.openAccept,
          onDecline: _ctx.openDecline
        }, null, 8, ["person", "is-confirm-loading", "is-decline-loading", "is-can-confirm", "is-can-decline", "onConfirm", "onDecline"]))
      : _createCommentVNode("", true),
    (_ctx.isCompanyInformationRender)
      ? (_openBlock(), _createBlock(_component_company_information, {
          key: 5,
          class: "mt-6",
          company: _ctx.state.company_information,
          "is-confirm-loading": _ctx.state.is_company_confirm_loading,
          "is-decline-loading": _ctx.state.is_company_decline_loading,
          "is-can-confirm": _ctx.isCanConfirm && !!_ctx.state.company_bin,
          "is-can-decline": _ctx.isCanDecline && !!_ctx.state.company_bin,
          onConfirm: _ctx.openAccept,
          onDecline: _ctx.openDecline
        }, null, 8, ["company", "is-confirm-loading", "is-decline-loading", "is-can-confirm", "is-can-decline", "onConfirm", "onDecline"]))
      : _createCommentVNode("", true),
    (_ctx.isAutoInformationRender)
      ? (_openBlock(), _createBlock(_component_auto_information, {
          key: 6,
          class: "mt-6",
          auto: _ctx.state.auto_information,
          "auto-number": _ctx.state.auto_number_temp,
          "auto-technical-passport": _ctx.state.auto_technical_passport_temp,
          "is-confirm-loading": _ctx.state.is_auto_confirm_loading,
          "is-decline-loading": _ctx.state.is_auto_decline_loading,
          "is-can-confirm": _ctx.isCanConfirm && !!_ctx.state.auto_number && !!_ctx.state.auto_technical_passport,
          "is-can-decline": _ctx.isCanDecline && !!_ctx.state.auto_number && !!_ctx.state.auto_technical_passport,
          onConfirm: _ctx.openAccept,
          onDecline: _ctx.openDecline
        }, null, 8, ["auto", "auto-number", "auto-technical-passport", "is-confirm-loading", "is-decline-loading", "is-can-confirm", "is-can-decline", "onConfirm", "onDecline"]))
      : _createCommentVNode("", true),
    (_ctx.isHistory)
      ? (_openBlock(), _createBlock(_component_history, {
          key: 7,
          class: "mt-6",
          identifier: _ctx.getIdentifier,
          type: _ctx.currentType
        }, null, 8, ["identifier", "type"]))
      : _createCommentVNode("", true)
  ]))
}